import { getEcuadorServerDate } from "@/hooks/getEcuadorTime";
import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

export const checkIfSessionExistsToday = async (userId: string) => {
  try {
    const ecuadorDate = await getEcuadorServerDate();
    ecuadorDate.setHours(0, 0, 0, 0);

    const tomorrow = new Date(ecuadorDate);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const response = await databases.listDocuments(
      import.meta.env.VITE_APPWRITE_DATABASE_ID,
      import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID,
      [
        Query.equal("userId", userId),
        Query.greaterThanEqual("clockIn", ecuadorDate.toISOString()),
        Query.lessThan("clockIn", tomorrow.toISOString()),
      ]
    );

    return response.documents.length > 0;
  } catch (error) {
    console.error("Error comprobando si ya hay jornada hoy:", error);
    return false;
  }
};
